export class BlockedDate {

    id: number;
    date: string;
    dispatch_group_id: number;
    created: string;

    constructor(date: string, dispatch_group_id: number) {
        this.date = date;
        this.dispatch_group_id = dispatch_group_id;
    }
}
